function DeviceClusterEnrollee(aId, aEnrolleeId, aIsActive, aTransactionId) {
    "use strict";

    this.__type = 'DeviceClusterEnrollee:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.DeviceClusterId = aId;
    this.EnrolleeId = aEnrolleeId;
    this.IsActive = aIsActive;
    this.TransactionId = aTransactionId;
}
if (typeof exports !== 'undefined') {
    module.exports = DeviceClusterEnrollee;
}